// extracted by mini-css-extract-plugin
export default {"imgBox":"Blogs_imgBox__lNTpC","cardBody":"Blogs_cardBody__N759l"};